import type { MatchTileAd } from "@/shared/MatchTileAd.jsx";
import { proxy } from "@/util/proxy.mjs";

type MatchTileAdRefs = {
  tiles: MatchTileAd[];
};

const refs = proxy<MatchTileAdRefs>({
  tiles: [],
});

export default refs;
